import { Routes, Route } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ScrollToTop from './components/ScrollToTop';
import Layout from './components/Layout';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import HowItWorksPage from './pages/HowItWorksPage';
import EducationPage from './pages/EducationPage';
import AthleteFormPage from './pages/AthleteFormPage';
import AthleteProfilePage from './pages/AthleteProfilePage';
import CommunityPage from './pages/CommunityPage';
import CommunityHubPage from './pages/CommunityHubPage';
import BaasPage from './pages/BaasPage';
import SportsOfficesPage from './pages/SportsOfficesPage';
import NewsPage from './pages/NewsPage';
import ContactPage from './pages/ContactPage';
import FaqPage from './pages/FaqPage';
import TokenPage from './pages/TokenPage';
import LegalPage from './pages/LegalPage';
import FundingPage from './pages/FundingPage';
import ClassicsPage from './pages/ClassicsPage';
import LegacyHubPage from './pages/LegacyHubPage';
import OneWorldPage from './pages/OneWorldPage';
import AuthPage from './pages/AuthPage';
import AdminDashboard from './pages/Admin/Dashboard';
import AdminApplications from './pages/Admin/Applications';
import DebugConsole from './components/DebugConsole';

function App() {

  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/how-it-works" element={<HowItWorksPage />} />
          <Route path="/funding" element={<FundingPage />} />
          <Route path="/education" element={<EducationPage />} />
          <Route path="/auth" element={<AuthPage />} />
          <Route path="/apply" element={<AthleteFormPage />} />
          <Route path="/athlete-profile" element={<AthleteProfilePage />} />
          <Route path="/community" element={<CommunityPage />} />
          <Route path="/community-hub" element={<CommunityHubPage />} />
          <Route path="/baas" element={<BaasPage />} />
          <Route path="/sports-offices" element={<SportsOfficesPage />} />
          <Route path="/news" element={<NewsPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/faq" element={<FaqPage />} />
          <Route path="/token" element={<TokenPage />} />
          <Route path="/legal" element={<LegalPage />} />
          <Route path="/legacy" element={<LegacyHubPage />} />
          <Route path="/legacy/classics" element={<ClassicsPage />} />
          <Route path="/legacy/one-world" element={<OneWorldPage />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/admin/applications" element={<AdminApplications />} />
        </Route>
      </Routes>
      <ToastContainer
        position="bottom-left"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        className="z-[40000]"
      />
      <DebugConsole />
    </>
  );
}

export default App;